import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import SvgIcon from '@material-ui/core/SvgIcon';
import {go} from '../../utils/navigationUtility';
import './button.scss';

@inject('dialogStore')
@observer
class BaseButtonWithIcon extends Component {
    handleClick = (e) => {
        const {goTo, onClick, clickHandler} = this.props;
        if (onClick) {
            onClick(e);
        } else if (clickHandler) {
            clickHandler(e);
        }
        if (goTo) {
            this.props.dialogStore.resetAllDialogs();
            go(goTo);
        }
    };

    render() {
        const {icon, ReactIcon, viewBox, iconSize, clickHandler, goTo, dialogStore, label, ...rest} = this.props;

        return (
            <Button onClick={this.handleClick} classes={{root: 'base-button-with-icon', label: 'btn-inner'}} {...rest}>
                {ReactIcon && <ReactIcon/>}
                {icon && <span className="btn-icon"><SvgIcon style={{fontSize: iconSize}} viewBox={viewBox}>{icon}</SvgIcon></span>}
                <span className="btn-label">{label}</span>
            </Button>
        );
    }
}

BaseButtonWithIcon.propTypes = {
    icon: PropTypes.any,
    viewBox: PropTypes.string,
    label: PropTypes.string,
    iconSize: PropTypes.string,
    goTo: PropTypes.string,
    onClick: PropTypes.func,
    clickHandler: PropTypes.func
};

export default BaseButtonWithIcon;
